export default "__VITE_ASSET__CC7KX2Yj__"